import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "..";
import service from "../../services/api.service";
import { plainToClass } from "class-transformer";
import { getTenantId } from "@/store/helper";
import { GuidItemModel } from "../models/shared/guidItem";
import { Guid } from "guid-typescript";
import _ from "lodash";
import { IPAStepDTO, PAStepModel } from "../models/paStep/paStepDTO";
import { IPAStepListingResponse } from "../models/paStep/response/paStepListingResponse";
import { IPAStepGridViewDTO, PAStepGridViewModel } from "../models/paStep/paStepGridViewDTO";
import { Vue } from "vue-property-decorator";
let PAStepsModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    let PAStepsModule = class PAStepsModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.apiNode = "paStep";
            this.steps = [];
            this.totalCount = 0;
            this.employees = [];
            this.roles = [];
            this.targetAudiences = [];
            this.step = null;
        }
        async GetSteps() {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetSteps(plainToClass(PAStepGridViewModel, data.steps));
                this.SetTotalCount(data.totalCount);
                this.SetDetails(data);
                return data;
            }
        }
        SetSteps(steps) {
            this.steps = steps;
        }
        SetTotalCount(totalCount) {
            this.totalCount = totalCount;
        }
        SetDetails(data) {
            this.employees = plainToClass(GuidItemModel, data.employees);
            this.roles = plainToClass(GuidItemModel, data.roles);
            this.targetAudiences = plainToClass(GuidItemModel, data.targetAudiences);
        }
        async AddStep(item) {
            var url = `${getTenantId()}/${this.apiNode}/add`;
            let { data } = await service.post(url, item);
            if (data) {
                this.SetStepData(plainToClass(PAStepGridViewModel, data.step));
                return data;
            }
        }
        async updateStepOrder(item) {
            var url = `${getTenantId()}/${this.apiNode}/updateStepOrder`;
            let { data } = await service.post(url, item);
            return data;
        }
        async EditStep(item) {
            var url = `${getTenantId()}/${this.apiNode}/edit`;
            let { data } = await service.post(url, item);
            if (data) {
                this.SetStepData(plainToClass(PAStepGridViewModel, data.step));
                return data;
            }
        }
        SetStepData(step) {
            const existingIndex = this.steps.findIndex((s) => s.id === step.id);
            if (existingIndex !== -1) {
                Vue.set(this.steps, existingIndex, step);
            }
            else {
                this.steps.push(step);
            }
            this.steps = _.sortBy(this.steps, (item) => item.name);
        }
        async GetStepDetailById(stepId) {
            var url = `${getTenantId()}/${this.apiNode}/${stepId}`;
            let { data } = await service.get(url);
            if (data) {
                this.SetStepDetail(plainToClass(PAStepModel, data.step));
                return data;
            }
        }
        SetStepDetail(step) {
            this.step = step;
        }
        async DeleteStepById(stepId) {
            var url = `${getTenantId()}/${this.apiNode}/delete/${stepId}`;
            let { data } = await service.delete(url);
            if (data) {
                this.RemoveStep(stepId);
                return data;
            }
        }
        RemoveStep(stepId) {
            this.steps = this.steps.filter((step) => step.id !== stepId);
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_a = typeof Promise !== "undefined" && Promise) === "function" ? _a : Object)
    ], PAStepsModule.prototype, "GetSteps", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], PAStepsModule.prototype, "SetSteps", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], PAStepsModule.prototype, "SetTotalCount", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof IPAStepListingResponse !== "undefined" && IPAStepListingResponse) === "function" ? _b : Object]),
        __metadata("design:returntype", void 0)
    ], PAStepsModule.prototype, "SetDetails", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof IPAStepDTO !== "undefined" && IPAStepDTO) === "function" ? _c : Object]),
        __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
    ], PAStepsModule.prototype, "AddStep", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
    ], PAStepsModule.prototype, "updateStepOrder", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof IPAStepDTO !== "undefined" && IPAStepDTO) === "function" ? _f : Object]),
        __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
    ], PAStepsModule.prototype, "EditStep", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_h = typeof IPAStepGridViewDTO !== "undefined" && IPAStepGridViewDTO) === "function" ? _h : Object]),
        __metadata("design:returntype", void 0)
    ], PAStepsModule.prototype, "SetStepData", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_j = typeof Guid !== "undefined" && Guid) === "function" ? _j : Object]),
        __metadata("design:returntype", typeof (_k = typeof Promise !== "undefined" && Promise) === "function" ? _k : Object)
    ], PAStepsModule.prototype, "GetStepDetailById", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_l = typeof IPAStepDTO !== "undefined" && IPAStepDTO) === "function" ? _l : Object]),
        __metadata("design:returntype", void 0)
    ], PAStepsModule.prototype, "SetStepDetail", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_m = typeof Guid !== "undefined" && Guid) === "function" ? _m : Object]),
        __metadata("design:returntype", Promise)
    ], PAStepsModule.prototype, "DeleteStepById", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_o = typeof Guid !== "undefined" && Guid) === "function" ? _o : Object]),
        __metadata("design:returntype", void 0)
    ], PAStepsModule.prototype, "RemoveStep", null);
    PAStepsModule = __decorate([
        Module({ dynamic: true, store: store, name: "paStep", namespaced: true })
    ], PAStepsModule);
    return PAStepsModule;
})();
export const PAStepModule = getModule(PAStepsModule);
